import { combineReducers } from '@reduxjs/toolkit';
import loading, { loadingInitialState } from './slicers/loading.slice';
import apiMessage, { apiMessageInitialState } from './slicers/api-message.slice';
import auth, { authInitialState } from './slicers/auth.slice';
import virtualAccount, { virtualAccountInitialState } from '@/redux/slicers/virtual-account.slice';
import card, { cardInitialState } from './slicers/card.slice';
import customerRequest, {
  customerRequestInitialState,
} from '@/redux/slicers/customer-request.slice';
import instrumentRequest, {
  instrumentRequestInitialState,
} from '@/redux/slicers/instrument-request.slice';
import transaction, { transactionInitialState } from './slicers/transaction.slice';
import dashboard, { dashboardInitialState } from '@/redux/slicers/dashboard.slice';
import invite, { inviteInitialState } from '@/redux/slicers/invite.slice';
import permission, { permissionInitState } from './slicers/permission.slice';
import setting, { settingInitialState } from '@/redux/slicers/setting.slice';
import chatbot, { chatbotInitialState } from '@/redux/slicers/chatbot.slice';
import cryptoDeposits, { cryptoDepositsInitialState } from '@/redux/slicers/crypto-deposits.slice';
import breadcrumb, { breadcrumbInitialState } from '@/redux/slicers/breadcrumb.slice';
import cashback, { cashbackInitialState } from '@/redux/slicers/cashback.slice';
import entityContext, { entityContextInitialState } from '@/redux/slicers/entity-context.slice';
import walletDetail, { walletDetailInitialState } from './slicers/wallet-detail.slice';
import wallets, { walletsInitialState } from '@/redux/slicers/wallets.slice';
import receivingAccounts, {
  receivingAccountInitialState,
} from '@/redux/slicers/receiving-account.slice';
import sidebar, { sidebarInitialState } from '@/redux/slicers/sidebar.slice';
import entityPermission, { entityPermissionInitialState } from '@/redux/slicers/entity-permission.slice';
import department, { departmentInitialState } from '@/redux/slicers/department.slice';
import fxConversion, { fxConversionInitialState } from '@/redux/slicers/fx-conversion.slice';
import notificationSettings, { notificationSettingsInitialState } from '@/redux/slicers/notification-settings.slice';
import notificationFeed, { notificationFeedInitialState } from '@/redux/slicers/notification-feed.slice';

export type RawRootState = typeof rootState;
export const allInitialStates = {
  fxConversionInitialState,
  dashboardInitialState,
  loadingInitialState,
  apiMessageInitialState,
  authInitialState,
  virtualAccountInitialState,
  cardInitialState,
  customerRequestInitialState,
  instrumentRequestInitialState,
  transactionInitialState,
  inviteInitialState,
  permissionInitState,
  settingInitialState,
  chatbotInitialState,
  cryptoDepositsInitialState,
  breadcrumbInitialState,
  cashbackInitialState,
  entityContextInitialState,
  walletsInitialState,
  receivingAccountInitialState,
  walletDetailInitialState,
  sidebarInitialState,
  entityPermissionInitialState,
  departmentInitialState,
  notificationSettingsInitialState,
  notificationFeedInitialState,
};
const rootState = {
  fxConversion,
  dashboard,
  loading,
  apiMessage,
  auth,
  virtualAccount,
  card,
  customerRequest,
  instrumentRequest,
  transaction,
  invite,
  permission,
  setting,
  chatbot,
  cryptoDeposits,
  breadcrumb,
  cashback,
  entityContext,
  wallets,
  receivingAccounts,
  walletDetail,
  sidebar,
  entityPermission,
  department,
  notificationSettings,
  notificationFeed,
};
const rootReducer = combineReducers(rootState);
export const rootReducers = rootReducer;
export type RootState = ReturnType<typeof rootReducer>;
export default rootReducer;
